import _ from "underscore";
import moment from "moment-mini";

export default class ChartDataPreparer {

    constructor(chartData) {
        this.chartData = chartData;
    }

    byDays(maxItems = 32) {
        let tmp = _.chain(this.chartData).groupBy(item => {
            return moment(item.datetime).format("YYYY-MM-DD")
        }).map((item, date) => {

            let avg = _.reduce(item, (memo, item) => {
                return (memo * 1) + (item.value * 1)
            }, 0);

            return {
                date: date,
                avgVal: Math.floor(avg / item.length)
            };

        }).value()

        tmp.sort((a, b) => {
            return moment(a.date, "YYYY-MM-DD").format("X") - moment(b.date, "YYYY-MM-DD").format("X")
        })

        return {
            labels: tmp.map(item => item.date).reverse().slice(0, maxItems).reverse(),
            chartData: tmp.map(item => item.avgVal).reverse().slice(0, maxItems).reverse(),
        };
    }

    byToday(maxItems = 24) {

        let tmp = _.chain(this.chartData).groupBy(item => {
            return moment(item.datetime).format("YYYY-MM-DD HH")
        }).map((item, date) => {
            let avg = _.reduce(item, (memo, item) => {
                return (memo * 1) + (item.value * 1)
            }, 0);

            return {
                date: date,
                avgVal: Math.floor(avg / item.length)
            };

        }).filter(item => {
            return moment(item.date, "YYYY-MM-DD HH").isSameOrAfter(moment().startOf("day"));
        }).value();

        let dummyData = _.map(this.getDummyTodayData(), item => {
            let find = _.find(tmp, item2 => {
                return item.date === item2.date;
            })
            item.avgVal = find?.avgVal || 0

            return item;
        });

        return {
            labels: dummyData.map(item => item.date + ":00").slice(0, maxItems),
            chartData: dummyData.map(item => item.avgVal).slice(0, maxItems),
        };
    }

    byHours(maxItems = 24) {
        let tmp = _.chain(this.chartData).groupBy(item => {
            return moment(item.datetime).format("YYYY-MM-DD HH")
        }).map((item, date) => {

            let avg = _.reduce(item, (memo, item) => {
                return (memo * 1) + (item.value * 1)
            }, 0);

            return {
                date: date,
                avgVal: Math.floor(avg / item.length)
            };

        }).value()

        let tmp2 = tmp.slice(0, maxItems);

        tmp2.sort((a, b) => {
            return moment(a.date, "YYYY-MM-DD HH").format("X") - moment(b.date, "YYYY-MM-DD HH").format("X")
        })

        return {
            labels: tmp2.map(item => item.date + ":00"),
            chartData: tmp2.map(item => item.avgVal),
        };
    }

    getDummyTodayData() {
        let start = moment().startOf("day").format("YYYY-MM-DD HH");

        return _.map(new Array(24), () => {

            let data = {
                date: start,
                avgVal: 0
            };

            start = moment(start).add(1, "hours").format("YYYY-MM-DD HH");

            return data;
        });
    }

}